export enum ThesisOrderStatusesEnum {
  created = 1,
  file_uploaded = 2,
  token_received = 3,
  payment_created = 4,
  paid = 5,
  canceled_by_payer = 6,
  payment_rejected = 7,
  payment_refunded = 8,
  sent_to_pko = 9,
  pko_evaluated = 10,
  paid_by_promo_code = 11,
  sent_to_pko_failure = 12,
  pko_evaluation_failure = 13
}

export const THESIS_ORDER_STATUSES = [
  {
    id: ThesisOrderStatusesEnum.created,
    title: 'CREATED'
  },
  {
    id: ThesisOrderStatusesEnum.file_uploaded,
    title: 'FILE_UPLOADED'
  },
  {
    id: ThesisOrderStatusesEnum.token_received,
    title: 'TOKEN_RECEIVED'
  },
  {
    id: ThesisOrderStatusesEnum.payment_created,
    title: 'PAYMENT_CREATED'
  },
  {
    id: ThesisOrderStatusesEnum.paid,
    title: 'PAID'
  },
  {
    id: ThesisOrderStatusesEnum.canceled_by_payer,
    title: 'CANCELED_BY_PAYER'
  },
  {
    id: ThesisOrderStatusesEnum.payment_rejected,
    title: 'PAYMENT_REJECTED'
  },
  {
    id: ThesisOrderStatusesEnum.payment_refunded,
    title: 'PAYMENT_REFUNDED'
  },
  {
    id: ThesisOrderStatusesEnum.sent_to_pko,
    title: 'SENT_TO_PKO'
  },
  {
    id: ThesisOrderStatusesEnum.pko_evaluated,
    title: 'PKO_EVALUATED'
  },
  {
    id: ThesisOrderStatusesEnum.paid_by_promo_code,
    title: 'PAID_BY_PROMO_CODE'
  },
  {
    id: ThesisOrderStatusesEnum.sent_to_pko_failure,
    title: 'SENT_TO_PKO_FAILURE'
  },
  {
    id: ThesisOrderStatusesEnum.pko_evaluation_failure,
    title: 'PKO_EVALUATION_FAILURE'
  }
];
